import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import Button from '@sorare/core/src/atoms/buttons/Button';
import { SorareLogo } from '@sorare/core/src/atoms/icons/SorareLogo';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { Img } from '@sorare/core/src/atoms/ui/Img';
import { useIsTabletAndAbove } from '@sorare/core/src/hooks/device/useIsTabletAndAbove';
import { glossary } from '@sorare/core/src/lib/glossary';
import {
  laptopAndAbove,
  tabletAndAbove,
} from '@sorare/core/src/style/mediaQuery';

import { Props } from 'pages/bestofeurope/types';

import bgAvif from './assets/bg.avif';
import bg from './assets/bg.jpg';
import leaguesAvif from './assets/leagues.avif';
import leagues from './assets/leagues.png';
import logo from './assets/logo.svg';
import teamAvif from './assets/team.avif';
import team from './assets/team.png';

const Root = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-image: url(${bg}});
  background-image: image-set(url(${bgAvif}) type('image/avif'), url(${bg}));
  background-size: cover;
  background-position: center;
  padding: var(--double-unit) var(--double-unit) 0;
  @media ${tabletAndAbove} {
    aspect-ratio: 1440 / 810;
  }
  &.fullScreen {
    height: var(--100vh);
    width: 100%;
    aspect-ratio: none !important;
  }
`;
const Logo = styled(SorareLogo)`
  max-width: 196px;
  width: 100%;
  height: auto;
`;

const StyledTitle = styled.div`
  text-transform: uppercase;
`;

const StyledSubtitle = styled.h2`
  font-size: var(--fs-10);
  letter-spacing: 0.3em;
  font-weight: 400;
  text-transform: uppercase;
  @media ${tabletAndAbove} {
    font-size: var(--fs-18);
  }
  @media ${laptopAndAbove} {
    font-size: var(--fs-24);
  }
`;

export const Hero = ({
  signUp,
  fullScreen,
}: Props & { fullScreen?: boolean }) => {
  const isTabletAndAbove = useIsTabletAndAbove();

  return (
    <Root className={classNames('text-center', { fullScreen })}>
      <Vertical center gap={4}>
        <Logo />
        <Vertical center gap={3}>
          <div>
            <StyledTitle>
              <Img src={logo} alt="" width="800" height="77" />
            </StyledTitle>
            <StyledSubtitle>
              <FormattedMessage
                id="BestOfEurope.Hero.subtitle"
                defaultMessage="The best of Europe competitions"
              />
            </StyledSubtitle>
          </div>
          <FormattedMessage
            id="BestOfEurope.Hero.description"
            defaultMessage="Free-to-play competitions every Tuesday and Friday with amazing football prizes"
          />
          <Button size="medium" color="secondary" onClick={signUp}>
            <FormattedMessage {...glossary.playNow} />
          </Button>
          <picture>
            <source srcSet={leaguesAvif} type="image/avif" />
            <Img src={leagues} fetchpriority="low" width="427" height="63" />
          </picture>
          {!isTabletAndAbove && (
            <picture>
              <source srcSet={teamAvif} type="image/avif" />
              <Img src={team} fetchpriority="low" width="342" height="241" />
            </picture>
          )}
        </Vertical>
      </Vertical>
    </Root>
  );
};
